<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="400px" persistent>
    <v-card>
      <v-card-title class="title">
        Map the Influencer on behalf
      </v-card-title>
      <v-card-text class="body-2">
        <p v-if="postData">
          The post is submitted by 
          <strong v-if="postData.submitedBy && postData.submitedBy.tiktokHandle">@{{postData.submitedBy.tiktokHandle}}</strong>
          <strong v-else-if="postData.submitedBy && postData.submitedBy.youtubeHandle">@{{postData.submitedBy.youtubeHandle}}</strong>
          <strong v-else-if="postData.submitedBy && postData.submitedBy.linkedinHandle">@{{postData.submitedBy.linkedinHandle}}</strong>
          <strong v-else-if="postData.submitedBy && postData.submitedBy.instagramHandle">@{{postData.submitedBy.instagramHandle}}</strong>
          <strong v-else>-</strong>
          for the <strong>{{postData.campaignName}}</strong> campaign.
        </p>
        <v-radio-group
          v-model="platform"
          row
        >
          <v-radio
            label="Instagram"
            value="instagram"
          ></v-radio>
          <v-radio
            label="TikTok"
            value="tiktok"
          ></v-radio>
          <v-radio
            label="Youtube"
            value="youtube"
          ></v-radio>
          <v-radio
            label="LinkedIn"
            value="linkedin"
          ></v-radio>
        </v-radio-group>
        <v-text-field
          prefix="@"
          label="Handle"
          v-model="handle"
          block
          :disabled="isValidating"
          outlined
        ></v-text-field>
      </v-card-text>
      <v-card-actions>        
        <v-btn color="red" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="saveMappedInfluencer()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import config from '@/config';
import postAPIs from './postApi';
// import influencerAPIs from '../Influencer/influencerAPIs';

export default {
  props: {
    value: Boolean,
    post: Object
  },
  data () {
    return {
      platform: 'instagram',
      postData: null,
      isValidating: false,
      handle: '',
      mapInfluencerObj: {
        instagramHandle: null,
        instagramID: null,
        picture: null
      }
    }
  },
  methods: {
    saveMappedInfluencer() {
      this.isValidating = true;
      postAPIs
        .mapInfluencerToPost(this.postData._id, {handle: this.handle, platform: this.platform})
        .then(response => {
          this.isValidating = false;
          this.$emit('successInfluencerMap')
          this.close()
        })
        .catch(error => {
          this.isValidating = false;
          this.$swal({
            type: 'error',
            text: error
          })
          console.log(error)
        })
    },
    close() {
      this.igHandle = '';
      this.mapInfluencerObj = {}
      this.$emit('input');
    }
  },
  watch: {
    post(newPost) {
      if (newPost !== null) {
        this.postData = newPost
        this.igHandle = newPost.mapInfluencer ? newPost.mapInfluencer.instagramHandle : ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MapInfluencerModal.vue?42a65fa0